import { APIS,TENANT_ID } from '../../../../utils/api-factory'
import { TENANT_HEADER, TENANT_POST_HEADER } from '../../../../utils/apiHeaders'
import axios from 'axios'


export const getEmailTemplatesList = (id,callBack, error) => {
    axios.get(APIS.GET_EMAIL_TEMPALTES_LIST + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getEmailTemplateSearchBySubjectKeyword = (keyword, callBack, error) => {
    axios.get(APIS.GET_EMAIL_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS + keyword, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const deleteEmailTemplateById = (id,callBack, error) => {
    axios.delete(APIS.DELETE_EMAIL_TEMPALTE_BY_ID + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const SaveEmailTemplateByData = (data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.SAVE_EMAIL_TEMPALTE_BY_DATA,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const UpdateEmailTemplateByData = (id,data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_EMAIL_TEMPALTE_BY_DATA_ID + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}


export const getsmsTemplatesList = (id,callBack, error) => {
    axios.get(APIS.GET_SMS_TEMPALTES_LIST + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getsmsTemplateSearchBySubjectKeyword = (keyword, callBack, error) => {
    axios.get(APIS.GET_SMS_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS + keyword, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const deletesmsTemplateById = (id,callBack, error) => {
    axios.delete(APIS.DELETE_SMS_TEMPALTE_BY_ID + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const SavesmsTemplateByData = (data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.SAVE_SMS_TEMPALTE_BY_DATA ,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const UpdatesmsTemplateByData = (id,data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_SMS_TEMPALTE_BY_DATA_ID + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}


export const getWhatsappTemplatesList = (id,callBack, error) => {
    axios.get(APIS.GET_WHATSAPP_TEMPALTES_LIST + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getWhatsappTemplateSearchBySubjectKeyword = (keyword, callBack, error) => {
    axios.get(APIS.GET_WHATSAPP_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS + keyword, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const deleteWhatsappTemplateById = (id,callBack, error) => {
    axios.delete(APIS.DELETE_WHATSAPP_TEMPALTE_BY_ID + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const SaveWhatsappTemplateByData = (data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.SAVE_WHATSAPP_TEMPALTE_BY_DATA,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const UpdateWhatsappTemplateByData = (id,data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_WHATSAPP_TEMPALTE_BY_DATA_ID + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getNotificationTemplatesList = (id,callBack, error) => {
    axios.get(APIS.GET_NOTIFICATION_TEMPALTES_LIST + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getNotificationTemplateSearchBySubjectKeyword = (keyword, callBack, error) => {
    axios.get(APIS.GET_NOTIFICATION_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS + keyword, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const deleteNotificationTemplateById = (id,callBack, error) => {
    axios.delete(APIS.DELETE_NOTIFICATION_TEMPALTE_BY_ID + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const SaveNotificationTemplateByData = (data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.SAVE_NOTIFICATION_TEMPALTE_BY_DATA,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const UpdateNotificationTemplateByData = (id,data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_NOTIFICATION_TEMPALTE_BY_DATA_ID + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getCallTemplatesList = (id,callBack, error) => {
    axios.get(APIS.GET_CALL_TEMPALTES_LIST + id, TENANT_HEADER)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const getCallTemplateSearchBySubjectKeyword = (keyword, callBack, error) => {
    axios.get(APIS.GET_CALL_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS + keyword, TENANT_HEADER)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const deleteCallTemplateById = (id,callBack, error) => {
    axios.delete(APIS.DELETE_CALL_TEMPALTE_BY_ID + id, TENANT_HEADER)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const SaveCallTemplateByData = (data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.SAVE_CALL_TEMPALTE_BY_DATA,data, headerConfig)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}
export const getcallTemplatecampaignsByData = (type,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.get(APIS.GET_CALL_TEMPALTE_CAMPAGINS_BY_DATA + type, headerConfig)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}
export const getPreviouscallLogsHisotryByNumber = (number,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.get(APIS.GET_PREVIOUS_CALL_LOGS_HISTORY_BY_NUMBER + number, headerConfig)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const UpdateCallTemplateByData = (id,data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_CALL_TEMPALTE_BY_DATA_ID + id,data, headerConfig)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const getWorkFlowStepsOrdered = (callBack, error) => {
    axios.get(APIS.GET_WORKFLOW_STEPS_ORDERED, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getWorkFlowStepsOrderedNew = (callBack, error) => {
    axios.get(APIS.GET_WORKFLOW_STEPS_ORDERED_NEW, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}


export const getOverflowStepsSearchByName = (name,callBack, error) => {
    axios.get(APIS.GET_OVERFLOW_STEPS_BY_NAME_SEARCH + name, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const deleteWorkflowStepsById = (id,callBack, error) => {
    axios.delete(APIS.DELETE_WORKFLOW_STEPS_BY_ID + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const SaveWorkFlowSteps = (data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.SAVE_WORKFLOW_STEPS ,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const UpdateWorkFlowSteps = (id,data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_WORKFLOW_STEPS + id ,data, headerConfig)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const getListMappedForStepById = (id,callBack, error) => {
    axios.get(APIS.GET_LIST_MAPPED_TEMPLATES_LIST_BY_ID + id , TENANT_HEADER)
    .then(res => {
        callBack(res?.data)
    })
    .catch(e => {
        callBack("")
    })
}

export const MapStepsWithTemplate = (data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.post(APIS.MAP_STEPS_WITH_TEMPALTES ,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const deleteMappedStepsWithTemplate = (id,callBack, error) => {
    axios.delete(APIS.DELETE_MAPPED_STEPS_TEMPLATES + id, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const TestEmailTemplate = (email,id,data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.TEST_EMAIL_TEMPLATES + email + "&templateId=" + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const TestsmsTemplate = (number,id,data,callBack, error) => {
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.TEST_SMS_TEMPLATES + number + "&templateId=" + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const TestWhatsappTemplate = (number,id,data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.TEST_WHATSAPP_TEMPLATES + number + "&templateId=" + id,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getCommunicationTeamCodes = (callBack, error) => {
    
    axios.get(APIS.GET_COMMUNICATION_TEAM_CODES , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getCommunicationSenderHeader = (callBack, error) => {
    
    axios.get(APIS.GET_COMMUNICATION_SENDER_HEADERS , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const GetEmailTempalteFilesList = (callBack, error) => {
   
    axios.get(APIS.GET_EMAIL_TEMPLATE_FILES , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const deleteEmailTempalteFilesList = (fileId,secretKey,callBack, error) => {
   
    axios.delete(APIS.DELETE_EMAIL_TEMPALTE_FILES + fileId + "&secretKey=" + secretKey , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const DoNotifyById = (id,userId,callBack, error) => {
   
    axios.get(APIS.DO_NOTIFY_API_BYID + id + "&userId=" + userId , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const GetEmailTemplateHTML = (fileId,callBack, error) => {
   
    axios.get(APIS.GET_EMAIL_TEMPALTE_HTML + fileId  , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const getLogsList = (page,size,callBack, error) => {
   
    axios.get(APIS.GET_LOGS_LIST + page +"&size=" + size , TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const updateSystemPlanMapping = (id,data,callBack, error) => {
     const headerConfig = {
        headers:TENANT_POST_HEADER
    };
    axios.put(APIS.UPDATE_SYSTEM_PLAN_MAPPING + id ,data, headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const uploadEmailTempalteFilesList = (file, callBack) => {
  return new Promise((resolve, reject) => {
    let imageFormData = new FormData()
    imageFormData.append('file', file)
 
    var xhr = new XMLHttpRequest()

    xhr.open('post', APIS.UPLOAD_EMAIL_TEMPALTE_FILES, true)
    xhr.setRequestHeader('X-Tenant-ID', TENANT_ID)
    xhr.onload = function () {
      if (this.status == 200) {
         const jsonResponse = JSON.parse(this.response)
        resolve(this.response)
        callBack(jsonResponse)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send(imageFormData)
  })
}